export enum BoundaryStateEnum {
  EMPTY_STATE_IMAGE = 'empty-state--image',
  EMPTY_STATE_TITLE = 'empty-state--title',
  EMPTY_STATE_DESCRITION = 'empty-state--description',
  EMPTY_STATE_BUTTON = 'empty-state--button',
  ERROR_STATE_IMAGE = 'error-state--image',
  ERROR_STATE_TITLE = 'error-state--title',
  ERROR_STATE_DESCRIPTION = 'error-state--description',
  ERROR_STATE_TRY_AGAIN = 'error-state--try-again',
  ERROR_STATE_LINK_HOME_PAGE = 'error-state--home-page',
}
